import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b3632f50&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b3632f50&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=b3632f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3632f50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3632f50')) {
      api.createRecord('b3632f50', component.options)
    } else {
      api.reload('b3632f50', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b3632f50&scoped=true&", function () {
      api.rerender('b3632f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/hqMessageBox/index.vue"
export default component.exports